import * as React from 'react'
import { cn } from '@/lib/utils'
import { badgeVariants } from './badge-variants'
import type { VariantProps } from 'class-variance-authority'

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  }
)
Badge.displayName = 'Badge'
